import React from "react";
import StyledAppBar from "../Header/StyledAppBar"; // adjust import path to your actual header file

const PublicAgmRoute = ({ children }) => {
  return (
    <>
      <StyledAppBar />
      {children}
    </>
  );
};

export default PublicAgmRoute;